import config from 'shared/config/config.js';

export const trackEvent = (event, attrs) => {
  if (config.env === 'production') {
    // not logging attrs in google analytics.
    // our events are the same across Braze, GA & our analytics_event table.
    // logging the events in GA gives us some neat insights
    // but logging the attrs gives us no benefit,
    // unless they're fields we want to filter on in GA.
    // logging the attrs might introduce GDPR concerns so I disabled it here.
    window.gtag('event', event);
    //window.gtag('event', event, attrs);
  }
}
